<template>
    <div id="logout">
      <h2>ログアウトしました</h2>
      <hr>
      <p>TOPページに移動します</p>
    </div>
</template>

<script>
export default {
  name: 'Logout',
  created: function () {
    // delete session backend
    this.$axios.get(this.baseURL + '/logout', {
      withCredentials: true
    }).then(() => {
    }).catch(() => {
    })

    // delete cookie
    const date = new Date()
    date.setTime(0)
    document.cookie = 'easyuploader_api=;expires"' + date.toString()

    location.href = '/'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logout.vue